import { inject, Injectable } from '@angular/core';
import { getFullProxyPath } from '@app/core/config/url-paths.config';
import { ApiBaseService } from '@app/core/services/api-base.service';
import { environment } from '@environments/environment';
import { Store } from '@ngxs/store';
import { map, Observable } from 'rxjs';
import { SubNode } from '../models/catalogue.model';
import { UserContextSelectors } from '../state/user-context/user-context.selectors';

@Injectable({
  providedIn: 'root',
})
export class ProductCatalogueApiService {

  #store = inject(Store)
  #apiBaseService = inject(ApiBaseService)

  private readonly API_PATH_PRODUCTCATALOGUE: string = 'productcatalogue';

  getRootCatalogueNode(rootNodeId: string): Observable<any> {
    const payload = {
      rootNodeId,
    };

    return this.#apiBaseService.observablePost(
      `${this.API_PATH_PRODUCTCATALOGUE}/Fetch_RootCatalogueNode`,
      payload
    );
  }

  getSubCatalogueNodes(rootNodeId: string, parentNodeId: string): Observable<any> {
    const payload = {
      rootNodeId,
      parentNodeId,
    };

    return this.#apiBaseService.observablePost(`${this.API_PATH_PRODUCTCATALOGUE}/Fetch_SubCatalogueNodes`, payload);
  }

  private getSalesCompany(): string {
    const portalCompanies = this.#store.selectSnapshot(UserContextSelectors.portalCompanies)

    if (portalCompanies) {
      return portalCompanies[0];
    }

    return '';
  }

  getCatalogueItemImageUrl(imageFileName: string, imageFilePath: string): { URL: string; ApiPath: string } {
    const salesCompany: string = this.getSalesCompany();
    const uri = `productcatalogue/Fetch_CatalogueImageGet?salesCompany=${salesCompany}&imageFileName=${imageFileName}&imageFilePath=${encodeURI(
      imageFilePath
    )}`;
    const apiPath = environment.axApiProxyPath_Ax;
    const url = getFullProxyPath(uri);

    return { URL: url, ApiPath: apiPath };
  }

  getInventProductGroupBoms(): Observable<SubNode[]> {
    return this.#apiBaseService.observablePost<SubNode[]>(`${this.API_PATH_PRODUCTCATALOGUE}/GetInventProductGroupBoms`, {}).pipe(
      map(response => (response ?? []).map(node => ({
        ...node,
        shouldRender: node.Id !== 'Topp_CC',
        ImageFilepath: this.getCatalogueItemImageUrl(node.ImageFilename, node.ImageFilepath).URL
      })))
    )
  }
}
